import {
  ComponentStateManager,
  DataVizContainerCommonUtils,
} from '../../../common/types';
import { getLineChartDataFromOverTimeSegmentedResponse } from '../../over-time-segmented-utils';
import {
  OverTimeSegmentedVizData,
  OverTimeSegmentedVizExternalProps,
} from '../../types';
import {
  OverTimeSegmentedLineChartActions,
  OverTimeSegmentedLineChartState,
  OverTimeSegmentedLineChartUiComponentProps,
} from './types';

export const overTimeSegmentedLineChartDataToUiComponentProps = (
  data: OverTimeSegmentedVizData,
  externalProps: OverTimeSegmentedVizExternalProps,
  componentStateManager: ComponentStateManager<
    OverTimeSegmentedLineChartState,
    OverTimeSegmentedLineChartActions
  >,
  { t, dataFieldValueFormatter }: DataVizContainerCommonUtils
): OverTimeSegmentedLineChartUiComponentProps => {
  const { dataResponse, titleConfig, metricDetailsMap } = data;
  const { preferences } = externalProps;

  const { metric } = dataResponse;
  const metricDetail = metricDetailsMap[metric.value];
  if (!metricDetail) {
    throw new Error(
      `Invalid state. Metric details undefined for metric: ${metric.value}`
    );
  }

  const chartData = getLineChartDataFromOverTimeSegmentedResponse(
    dataResponse,
    metricDetail,
    preferences,
    t,
    dataFieldValueFormatter
  );

  const displayConfig = {
    ...componentStateManager.state.displayState,
    ...componentStateManager.actions.displayActions,
  };

  return {
    fullScreenHandle: externalProps.fullScreenHandle,
    displayConfig,
    titleConfig,
    chartData,
    chartColors: data.chartColors,
  };
};
